
import Vue from 'vue';
import { mapGetters } from 'vuex';
import RoleDefBadge from '@/views/Team/CompanyDashboard/RoleDefBadge.vue';

/**
 * The "How Automatic Assignment Works" explainer shown under an "Assigned Role" select when
 * "✨ Automatically assign" (a null teamUserRoleDefId) is chosen. Shared by the team invite
 * dialog (InviteTeamMember) and the page-level add company role dialog (AddCompanyUserRoleDialog).
 */
export default Vue.extend({
	name: 'RoleAutoAssignExplainer',
	props: {
		// The company's lowest-level TeamUserRoleDef — what a brand-new member gets by default.
		lowestRoleDef: { type: Object, default: null },
	},
	computed: {
		...mapGetters([
			'displayLabels',
		]),
	},
	components: {
		RoleDefBadge,
	},
});
